import { render, staticRenderFns } from "./MotDePasseOublie.vue?vue&type=template&id=648776c6"
import script from "./MotDePasseOublie.vue?vue&type=script&lang=ts"
export * from "./MotDePasseOublie.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports